import { css } from "@compiled/react";
import { defineMessage, FormattedMessage } from "react-intl";

import { N700 } from "@atlaskit/theme/colors";

import { AccountCreation } from "@/components/signup/account-creation/account-creation";
import { BanditsHeaderWrapper } from "@/utils/anchor-queries/bandits-components";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import { EmbeddedSignupFormWrapper } from "./components/embedded-signup-form-wrapper";
import { ExistingProductText } from "./components/existing-product-text";
import { SocialEndorsement } from "./components/social-endorsement";

const confluenceEmbeddedExistingText = defineMessage({
    id: "BxpUiSignup.SignupForm.existingProduct.confluence.embedded",
    defaultMessage: "Trying to access {product}? <logInLink>Log in</logInLink>"
});

export const CFindEmbeddedSignupForm = () => {
    const gwp9286ConfluenceAnchorUpdates = checkFeatureFlagGate(
        featureFlags.gwp9286ConfluenceAnchorUpdates
    );

    const defaultHeader = gwp9286ConfluenceAnchorUpdates ? (
        <FormattedMessage
            id="GWP9286ConfluenceAnchorUpdates.header.confluence.features"
            defaultMessage="Meet your new AI-powered workspace"
        />
    ) : (
        <FormattedMessage
            id="BxpUiSignup.EmbeddedSignupForm1466.header.confluence.features.gwp9286"
            defaultMessage="Goodbye silos, hello teamwork with Confluence"
        />
    );

    return (
        <EmbeddedSignupFormWrapper hideFooter={true}>
            <div css={containerStyle} data-testid="signup-form">
                <h1 css={headerStyle}>
                    <BanditsHeaderWrapper product="confluence" type="header">
                        {defaultHeader}
                    </BanditsHeaderWrapper>
                </h1>
                <h2 css={subheaderStyle}>
                    <BanditsHeaderWrapper product="confluence" type="subheader">
                        <FormattedMessage
                            id="BxpUiSignup.SignupForm.subheader.1"
                            defaultMessage="It's free for up to 10 users — no credit card needed."
                        />
                    </BanditsHeaderWrapper>
                </h2>
                <AccountCreation Login={null} />
                <SocialEndorsement />
                <ExistingProductText
                    messageOverride={confluenceEmbeddedExistingText}
                />
            </div>
        </EmbeddedSignupFormWrapper>
    );
};

const containerStyle = css({
    alignItems: "stretch",
    backgroundColor: "white",
    // eslint-disable-next-line
    boxShadow: "0px 14px 14px -4px rgba(0, 0, 0, 0.10)",
    borderRadius: "20px",
    color: N700,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    padding: "32px 50px",
    width: "468px"
});

const headerStyle = css({
    paddingInlineEnd: "64px",
    textAlign: "left !important"
});

const subheaderStyle = css({
    fontSize: "16px !important",
    fontWeight: "300 !important",
    textAlign: "left !important"
});
